import React from 'react'
import { LanguageProvider } from './src/i18n/i18n'

// Wrap the whole app in the language provider (used by both gatsby-browser and gatsby-ssr).
export const wrapRootElement = ({ element }) => <LanguageProvider>{element}</LanguageProvider>
